import {
  getSortedDraggables,
  isPositionChanged,
  getNewDraggablePosition,
  getAfterDropDraggableList,
} from 'shared/utils/draggables';
import { DropResult } from 'react-beautiful-dnd';
import { TaskGroup, Task } from 'shared/generated/graphql';

export type OnTaskDropFn = (task: Task, id: string) => void;
export type OnTaskGroupDropFn = (taskGroup: TaskGroup) => void;

type OnDragEndFn = (
  result: DropResult,
  taskGroups: any,
  onTaskGroupDrop: OnTaskGroupDropFn,
  onTaskDrop: OnTaskDropFn,
) => void;

const onDragEnd: OnDragEndFn = (
  { draggableId, source, destination, type },
  taskGroups,
  onTaskGroupDrop,
  onTaskDrop,
) => {
  if (typeof destination === 'undefined') return;
  if (!isPositionChanged(source, destination)) return;

  const isList = type === 'column';
  const isSameList = destination.droppableId === source.droppableId;
  let droppedDraggable: DraggableElement | null = null;
  let beforeDropDraggables: Array<DraggableElement> | null = null;

  if (isList) {
    const droppedGroup = taskGroups.find((taskGroup: any) => taskGroup.id === draggableId);
    if (droppedGroup) {
      droppedDraggable = {
        id: draggableId,
        position: droppedGroup.position,
      };
      beforeDropDraggables = getSortedDraggables(
        taskGroups.map((taskGroup: any) => {
          return { id: taskGroup.id, position: taskGroup.position };
        }),
      );
      if (droppedDraggable === null || beforeDropDraggables === null) {
        throw new Error('before drop draggables is null');
      }
      const afterDropDraggables = getAfterDropDraggableList(
        beforeDropDraggables,
        droppedDraggable,
        isList,
        isSameList,
        destination,
      );
      const newPosition = getNewDraggablePosition(afterDropDraggables, destination.index);
      onTaskGroupDrop({
        ...droppedGroup,
        position: newPosition,
      });
    } else {
      throw new Error('task group can not be found');
    }
  } else {
    const curTaskGroup = taskGroups.findIndex(
      (taskGroup: any) => taskGroup.tasks.findIndex((task: any) => task.id === draggableId) !== -1,
    );
    let targetTaskGroup = curTaskGroup;
    if (!isSameList) {
      targetTaskGroup = taskGroups.findIndex((taskGroup: any) => taskGroup.id === destination.droppableId);
    }
    const droppedTask = taskGroups[curTaskGroup].tasks.find((task: any) => task.id === draggableId);

    if (droppedTask) {
      droppedDraggable = {
        id: draggableId,
        position: droppedTask.position,
      };
      beforeDropDraggables = getSortedDraggables(
        taskGroups[targetTaskGroup].tasks.map((task: any) => {
          return { id: task.id, position: task.position };
        }),
      );
      if (droppedDraggable === null || beforeDropDraggables === null) {
        throw new Error('before drop draggables is null');
      }
      const afterDropDraggables = getAfterDropDraggableList(
        beforeDropDraggables,
        droppedDraggable,
        isList,
        isSameList,
        destination,
      );
      const newPosition = getNewDraggablePosition(afterDropDraggables, destination.index);
      const newTask = {
        ...droppedTask,
        position: newPosition,
        taskGroup: {
          id: destination.droppableId,
        },
      };
      onTaskDrop(newTask, droppedTask.taskGroup.id);
    }
  }
};

export default onDragEnd;
